export default __webpack_public_path__ + "static/media/socketStats.2036663f.png";